import { Focusable } from "../globals.consts";
import { Context } from "../modules/context/state/context.model";

export function getContextKey(params: {
  focus: string;
  context?: Context;
  categoryId?: string;
  deltaMode?: boolean;
}) {
  const { focus, context, categoryId, deltaMode } = params;
  switch (focus) {
    case Focusable.NodeTree:
      return context.c?.version?.uuid;
    case Focusable.FilterField:
      return `${categoryId}${deltaMode ? "-deltaMode" : ""}`;
  }
}
